/* eslint-disable no-param-reassign */

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['drawer', 'void'];

  openDrawer(e = null) {
    if (e) {
      e.preventDefault();
    }

    this.drawerTarget.style.left = '0';
    this.voidTarget.classList.add('d-block');
    this.voidTarget.classList.remove('d-none');
  }

  closeDrawer(e = null) {
    if (e) {
      e.preventDefault();
    }

    this.drawerTarget.style.left = '-336px';
    this.voidTarget.classList.add('d-none');
    this.voidTarget.classList.remove('d-block');
  }

  collapseToggle(e) {
    e.preventDefault();

    const el = e.target;
    const parentEl = el.parentNode;
    const subNav = parentEl.querySelector('.collapse');

    if (parentEl.classList.contains('active')) {
      parentEl.classList.remove('active');
      $(subNav).slideUp('fast');
    } else {
      parentEl.classList.add('active');
      $(subNav).slideDown('fast');
    }
  }

  beforeCache() {
    this.closeDrawer();
    this.element.querySelectorAll('.collapse').forEach((el) => {
      el.style.display = 'none';
      el.parentNode.classList.remove('active');
    });
  }
}
